module.exports = __webpack_public_path__ + "static/mainLogo-9a1e22676fb0a8f57d4ef03e4a91a8b7.png";